export const MEDIA_LIBRARY_OPEN_EVENT = "KnowfullyOpenMediaLibrary";
